<template>
  <div class="today">
    <mu-card class="menus-card">
      <mu-card-header title="常用功能"> </mu-card-header>
      <div slot class="menus-card-content">
        <mu-button
          color="primary"
          v-for="(item, index) in menuList"
          :key="index"
          @click="item.click"
          class="button"
        >
          <mu-icon :value="item.icon"></mu-icon>
          {{ item.name }}
        </mu-button>
      </div>
    </mu-card>
    <div class="card-wrapper">
      <mu-card class="order-card">
        <mu-card-header
          :title="`生产中订单(${orderList.length})`"
          class="order-card-header"
        >
        </mu-card-header>
        <div class="order-list">
          <mu-expansion-panel
            :expand="expandOrderId === item.id"
            v-for="(item, index) in orderList"
            :key="index"
            @change="expand(item)"
          >
            <div slot="header">
              {{
                moment(item.createTime).format('MM-DD') +
                '-' +
                item.orderId.toString().substr(-3) +
                '  ' +
                item.customer.company +
                ' - ' +
                item.customer.realName
              }}
            </div>
            <div slot>
              <div class="product-list">
                <div
                  class="product-item"
                  v-for="(product, productIndex) in item.products"
                  :key="productIndex"
                >
                  <div class="product-name">
                    {{ product.name }} * {{ product.count }}
                  </div>
                  <div class="product-specification">
                    {{ product.specification }}
                  </div>
                </div>
              </div>
            </div>
            <mu-button slot="action" color="primary">查看</mu-button>
            <mu-button slot="action" color="success" @click="complete(item)"
              >已完成</mu-button
            >
          </mu-expansion-panel>
        </div>
      </mu-card>
    </div>
    <OutCreate :open.sync="outCreate"></OutCreate>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
import moment from 'moment'
import OutCreate from './../out/create'
import { mapActions } from 'vuex'
export default {
  components: { OutCreate },
  data() {
    const self = this
    return {
      moment,
      orderList: [],
      expandOrderId: 0,
      menuList: [
        {
          name: '客户账务管理',
          icon: 'attach_money',
          click() {
            self.setMenuClickInOtherPage({
              url: '/admin/payment/customer',
              name: '客户账务管理',
              id: 160
            })
          }
        },
        {
          name: '查看订单',
          icon: 'assignment',
          click() {
            self.setMenuClickInOtherPage({
              url: '/admin/order/view',
              name: '查看订单',
              id: 149
            })
          }
        },
        {
          name: '下单',
          icon: 'pages',
          click() {
            self.setMenuClickInOtherPage({
              url: '/admin/order/newOrder',
              name: '下单',
              id: 139
            })
          }
        }
        // {
        //   name: '支出',
        //   icon: 'account_balance_wallet',
        //   click () {
        //     self.outCreate = true
        //   }
        // }
      ],
      outCreate: false
    }
  },
  methods: {
    // 刷新
    getAll() {
      this.getUncomplete()
    },
    expand(item) {
      this.expandOrderId = this.expandOrderId === item.id ? 0 : item.id
    },
    ...mapActions(['setMenuClickInOtherPage']),
    getUncomplete() {
      backend(api.order.getUncomplete).then((result) => {
        if (result.statusCode === 200) {
          this.orderList = result.data.rows
        }
      })
    },
    complete(order) {
      backend(api.order.complete, order).then((result) => {
        if (result.statusCode === 200) {
          this.getUncomplete()
        }
      })
    }
  },
  mounted() {
    this.getUncomplete()
  }
}
</script>

<style lang="less" scoped>
.today {
  background: #efefef;
  height: 100%;
  display: flex;
  flex-direction: column;
  .menus-card {
    .menus-card-content {
      padding: 10px;
      .button {
        margin-left: 10px;
      }
    }
  }
  .card-wrapper {
    flex: 1;
    display: flex;
    margin-top: 10px;
    .order-card {
      flex: 0 0 50%;
      display: flex;
      flex-direction: column;
      max-height: 100%;
      .order-list {
        flex: 1;
        overflow-y: scroll;
        .product-list {
          .product-item {
            display: flex;
            .product-name {
              flex: 0 0 240px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
            .product-specification {
              flex: 1;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/today/index.vue